import Paper from 'components/atoms/Paper'

export default {
  MuiTextField: {
    variant: 'outlined',
  },
  MuiButton: {
    variant: 'contained',
  },
  MuiInput: {
    disableUnderline: true,
  },
  MuiTypography: {
    gutterBottom: true,
  },
  MuiDialog: {
    PaperComponent: Paper,
    PaperProps: {
      variant: 'rounded',
    },
  },
}
